module.exports = __webpack_public_path__ + "assets/img/thumb-D3-Security-Content-Marketing.0f4d1b27.webp";